// Legacy duplicate of the path design panel.
// Current path authoring uses app/javascript/components/organisms/editor-design/EditorDesign.js
// via side-toolbar/index.jsx, so changes for the live design rail should go there first.
import React, { useEffect, useState } from "react";
import Accordion from "./Accordion";
import ContentForm from "./design/ContentForm";
import SettingsForm from "./design/SettingsForm";
import SingleSelection from "./design/SingleSelection";
import ActionsForm from "./design/ActionsForm";
import TextForm from "./design/TextForm";
import { useDispatch, useSelector } from "react-redux";
import { getLayerConfig, getMainConfig, updateLayerConfig, updateMainConfig } from "../../../../../../redux/stepsSlice";
import DesignOption from "../../../../../organisms/editor-design/DesignOption";

const Design = () => {
  const dispatch = useDispatch();
  const mainConfig = useSelector((state) => getMainConfig(state));
  const layerConfig = useSelector((state) => getLayerConfig(state));
  const [configs, setConfigs] = useState(
    layerConfig.length > 0 ? layerConfig : mainConfig
  );

  const isSameValue = (left, right) => {
    if (left === right) return true;
    const leftIsObject = typeof left === "object" && left !== null;
    const rightIsObject = typeof right === "object" && right !== null;
    if (!leftIsObject && !rightIsObject) return false;
    try {
      return JSON.stringify(left) === JSON.stringify(right);
    } catch (_error) {
      return false;
    }
  };

  const getCurrentValue = (sectionId, titleId) => {
    const sourceConfig = layerConfig.length > 0 ? layerConfig : mainConfig;
    const section = sourceConfig.find((item) => item.sectionId === sectionId);
    if (!section) return undefined;
    return section.values.find((value) => value.id === titleId)?.value;
  };

  const updateConfig = (sectionId, titleId, newValue) => {
    const currentValue = getCurrentValue(sectionId, titleId);
    if (isSameValue(currentValue, newValue)) return;

    const data = {
      sectionId: sectionId,
      titleId: titleId,
      value: newValue
    };
    if (layerConfig.length > 0) {
      dispatch(updateLayerConfig(data));
    } else {
      dispatch(updateMainConfig(data));
    }
  };

  useEffect(() => {
    if (layerConfig.length > 0) {
      setConfigs(layerConfig);
    } else {
      setConfigs(mainConfig);
    }
  }, [layerConfig, mainConfig]);

  const renderDesignOptions = (sectionId, values) => {
    return values.map((value) => (
      <DesignOption
        key={value.id}
        text={value.title}
        optionType={value.type}
        value={value.value}
        options={value.options}
        optionId={value.id}
        direction={value.direction}
        image_type={value.image_type}
        toolbarOptions={value.toolbarOptions}
        onChange={(newValue) => {
          updateConfig(sectionId, value.id, newValue);
        }}
      />
    ));
  };

  const renderConfig = () => {
    return configs.map((config, index) => (
      <Accordion isInitActive className="un-accordion" title={config.sectionTitle} key={index}>
        {renderDesignOptions(config.sectionId, config.values)}
      </Accordion>
    ));
  };

  return (
    // <div id="component-3" className="tab-content pane-switch-component-parts 123" style={{ maxHeight: "calc(100vh - 50px)", overflowY: 'auto'}}>
      <div className="un-editor-design">
        {renderConfig()}
      </div>
    // </div>
  );
}

export default Design;
